export default __webpack_public_path__ + "static/media/Series-S-3.df84c226.jpg";